import { render, staticRenderFns } from "./BillBoard.vue?vue&type=template&id=003453e5"
import script from "./BillBoard.vue?vue&type=script&lang=js"
export * from "./BillBoard.vue?vue&type=script&lang=js"
import style0 from "./BillBoard.vue?vue&type=style&index=0&id=003453e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports